const SETBLOCK = 'block/SETBLOCK';

type setBlockAction = {
    type: typeof SETBLOCK;
    payload: boolean;
};

type ActionType = |
    setBlockAction;

interface InitialStateType {
    status: boolean
}
const initialState: InitialStateType = {
    status: false
}

export const setBlock = (payload: boolean) => ({type: SETBLOCK, payload})

export default function block(state: InitialStateType = initialState, action:ActionType ) {
    switch(action.type) {
    case SETBLOCK:
        return {
            ...state,
            status: action.payload
        };
    default:
        return state;
    }
}